import React from "react";
import GroupList from "./GroupList";
import { getSessionUserId } from "../utils/auth";

const Groups = () => {
  return (
    <div>
      <p>Join a Group!</p>
      <GroupList userid={getSessionUserId()} />
    </div>
  );
};

export default Groups;
